import { OfficialList } from './OfficialList';
import { OfficialEdit } from './OfficialEdit';
import PersonIcon from '@material-ui/icons/Person';

export const OfficialIcon = PersonIcon;

export default {
    list: OfficialList,
    edit: OfficialEdit,
}